export const useSearchKeywords = () => {

    const searchKeywords = useState( 'searchKeywords', () => "" );

    const setKeywords = ( keywords ) => {
        searchKeywords.value = keywords;
    };

    return {
        searchKeywords,
        setKeywords,
    };
};
